import { Badge, BadgeProps, colors, styled } from '@mui/material';
import React from 'react';
import useCloudConnectPro from '../../../../redux/stoerkID/hooks/useCloudConnectPro';
import { useAppSelector } from '../../../../redux/store.model';
import { getFeatureToggle } from '../../../../featureToggle';
import { getPolyglot } from '../../../../i18n';

const BadgeStyled = styled(Badge)(({ theme }) => ({
  '& .MuiBadge-badge': {
    fontSize: 8,
    color: theme.palette.primary.contrastText,
    width: 30,
    height: 30,
    borderRadius: '50%',
  },
}));

function BadgePlan(props: BadgeProps) {
  const isCloudConnectPlus = useCloudConnectPro();
  const featureToggle = useAppSelector(getFeatureToggle);
  const showStoerkId = featureToggle?.stoerkId;
  const polyglot = getPolyglot();
  if (!showStoerkId) return null;
  const badgeContent = isCloudConnectPlus
    ? polyglot.t('stoerk_id.plans.plus_short')
    : polyglot.t('stoerk_id.plans.one_short');
  const color = isCloudConnectPlus ? 'secondary' : 'primary';
  return (
    <BadgeStyled
      color={color}
      badgeContent={badgeContent}
      overlap="circular"
      {...props}
    />
  );
}

export default BadgePlan;
